import './styles/app.scss';
import { h, render, Component } from 'preact';

import SuperNav from './components/SuperNav.js';
import Header from './components/Header.js';
import JobOpenings from './components/JobOpenings.js';
import OurStudio from './components/OurStudio.js';
import Footer from './components/Footer.js';

import MetaInformation from './components/MetaInformation.js';
import Provider from 'preact-context-provider';

const branding = {
	headerFont: '"Cinzel", serif',
	bodyFont: '"Roboto", sans-serif',
	logoSmall: 'https://webcdn.hirezstudios.com/studios/TitanForgeIcon.png',
	logoLarge: 'https://webcdn.hirezstudios.com/studios/TitanForgeFooterLogo.png',
	gameURL: 'https://www.smitegame.com',
	studioPhoto: 'https://webcdn.hirezstudios.com/studios/TitanForgeTeamPic.jpg',
	jobsUrl: 'https://www.hirezstudios.com/careers/',
	jobsBackground: 'https://webcdn.hirezstudios.com/studios/TitanForgeJobs.jpg',
	headerBackground: 'https://webcdn.hirezstudios.com/studios/TitanForgeHeader.jpg'
};

const colors = {
	primary: '#262E42',
	accent: '#61533D',
	link: '#FFFFFF',
	hoverLink: '#B1966F',
	copy: '#262E42'
};

const copy = {
	longName: 'Titan Forge Games',
	shortName: 'Titan Forge',
	gameName: 'Smite',
	tagLine: 'Enter The Battleground',
	aboutCopy: 'Titan Forge Games is the largest of Hi-Rez’s in-house studios and houses the team behind SMITE, a BAFTA award-winning online brawler with more than 30 million players worldwide. Combining mythological themes with modern flourishes, Titan Forge Games is dedicated to creating games which combine immersive creative universes with competitive gameplay on an epic scale.',
	footerCopy: ''
};

const meta = {
	favicon: 'https://webcdn.hirezstudios.com/studios/TitanForgeIcon.png',
	description: 'Titan Forge Games is the largest of Hi-Rez’s in-house studios and houses the team behind SMITE, a BAFTA award-winning online brawler with more than 30 million players worldwide. Combining mythological themes with modern flourishes, Titan Forge Games is dedicated to creating games which combine immersive creative universes with competitive gameplay on an epic scale.',
	url: 'https://www.titanforgegames.com',
	image: 'https://webcdn.hirezstudios.com/studios/evil-mojo-meta.jpg'
};

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}

	render() {
		return (
			<div className="page-titan-forge">
				<MetaInformation
					description={meta.description}
					favicon={meta.favicon}
					image={meta.image}
					title={copy.longName}
					url={meta.url}
				/>
				<SuperNav />
				<Header />
				<JobOpenings />
				<OurStudio />
				<Footer />
			</div>
		);
	}
}

if (typeof window !== 'undefined') {
	render(
		<Provider colors={colors} branding={branding} copy={copy}>
			<App />
		</Provider>,
		document.body
	);
}


// WEBPACK FOOTER //
// ./index.js